export default __webpack_public_path__ + "static/media/dustbin-pink-16px.7a38e3ac.svg";